"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const ErrorSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M52.2645 46.8125L29.5145 7.4375C29.1755 6.85234 28.5903 6.5625 27.9997 6.5625C27.409 6.5625 26.8184 6.85234 26.4848 7.4375L3.73483 46.8125C3.06218 47.9828 3.90436 49.4375 5.24968 49.4375H50.7497C52.095 49.4375 52.9372 47.9828 52.2645 46.8125ZM26.2497 22.75C26.2497 22.5094 26.4465 22.3125 26.6872 22.3125H29.3122C29.5528 22.3125 29.7497 22.5094 29.7497 22.75V32.8125C29.7497 33.0531 29.5528 33.25 29.3122 33.25H26.6872C26.4465 33.25 26.2497 33.0531 26.2497 32.8125V22.75ZM27.9997 42C27.3128 41.986 26.6587 41.7033 26.1779 41.2125C25.697 40.7217 25.4277 40.0621 25.4277 39.375C25.4277 38.6879 25.697 38.0283 26.1779 37.5375C26.6587 37.0467 27.3128 36.764 27.9997 36.75C28.6866 36.764 29.3406 37.0467 29.8215 37.5375C30.3023 38.0283 30.5716 38.6879 30.5716 39.375C30.5716 40.0621 30.3023 40.7217 29.8215 41.2125C29.3406 41.7033 28.6866 41.986 27.9997 42V42Z" fill="#F04438" />
  </svg>
)

const ErrorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ErrorSvg} {...props} />
);

export default ErrorIcon